const typography = { fontFamily: "Graphik" };

export default typography;
